import { Components, Theme } from '@mui/material';

export const getMuiTooltip = (theme: Theme): Components['MuiTooltip'] => ({
  styleOverrides: {
    tooltip: {
      backgroundColor: theme.palette.common.black,
      // `common` is inverted in dark mode (ENG-6264); pair with `common.white` for contrast.
      color: theme.palette.common.white,
      padding: theme.spacing(1, 2),
      fontSize: theme.typography.body1.fontSize,
    },
    arrow: {
      color: theme.palette.common.black,
    },
  },
});
